import { useGraphQLQuery } from '@betterment/js-runtime';
import { useFeatureFlag } from '@betterment/shared-components';

import { ChatbotEligibilityDocument } from './graphql/query.chatbotEligibility.generated';

import { useIsAuthenticated } from '../features/authentication/authentication';
import { isMobileWebview } from '../Shared/user-agent-helpers';

export function useZendeskChatbotConfig(): boolean {
  const { enabled: isFeatureFlagEnabled } = useFeatureFlag({
    splitName: 'retail.chatbot_react_conversion_q4_2025_enabled',
    context: 'Chatbot',
  });

  const isAuthenticated = useIsAuthenticated();
  const { data, loading } = useGraphQLQuery(ChatbotEligibilityDocument, {
    skip: !isAuthenticated,
    fetchPolicy: 'cache-first',
    throwOnError: false,
  });

  const isAdvised = Boolean(data?.advisor);
  const isMobileWebviewUser = isMobileWebview();
  const isEligible = !loading && !isMobileWebviewUser && isAuthenticated && !isAdvised;

  return isFeatureFlagEnabled && isEligible;
}
